(function () {
  var SELECTORS = {
    root: "[data-track-order]",
    form: "[data-track-order-form]",
    submit: "[data-track-order-submit]",
    message: "[data-track-order-message]",
    result: "[data-track-order-result]",
    statusLabel: "[data-track-order-status-label]",
    statusDescription: "[data-track-order-status-description]",
    orderName: "[data-track-order-name]",
    trackingNumber: "[data-track-order-number]",
    timeline: "[data-track-order-timeline]"
  };
  var IS_UK_STOREFRONT = window.location.hostname.indexOf("paintingbynumbers-expert.co.uk") !== -1;
  var TEXT = IS_UK_STOREFRONT
    ? {
        serviceMissing: "The track-and-trace service is not connected yet.",
        missingFields: "Enter your order number and email address or postcode.",
        orderNotFound: "We could not find your order.",
        statusLoaded: "Status loaded.",
        genericError: "Something went wrong. Please try again later.",
        statusUpdating: "Status is being updated",
        trackingUnavailable: "Not available yet",
        loading: "Loading status...",
        submit: "View status"
      }
    : {
        serviceMissing: "De track-and-trace service is nog niet gekoppeld.",
        missingFields: "Vul je ordernummer en e-mailadres of postcode in.",
        orderNotFound: "We konden je bestelling niet vinden.",
        statusLoaded: "Status opgehaald.",
        genericError: "Er ging iets mis. Probeer het later opnieuw.",
        statusUpdating: "Status wordt bijgewerkt",
        trackingUnavailable: "Nog niet beschikbaar",
        loading: "Status ophalen...",
        submit: "Status bekijken"
      };

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(SELECTORS.root).forEach(initTrackOrder);
  });

  function initTrackOrder(root) {
    var form = root.querySelector(SELECTORS.form);
    var submit = root.querySelector(SELECTORS.submit);
    var message = root.querySelector(SELECTORS.message);
    var result = root.querySelector(SELECTORS.result);

    if (!form || !submit || !message || !result) return;

    prefillFormFromUrl(form);

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      clearMessage(message);

      var apiUrl = root.getAttribute("data-track-order-api-url") || "";
      var endpoint = buildEndpoint(apiUrl);
      var payload = {
        orderNumber: form.elements.orderNumber.value.trim(),
        contact: form.elements.contact.value.trim()
      };

      if (!endpoint) {
        showMessage(message, TEXT.serviceMissing);
        return;
      }

      if (!payload.orderNumber || !payload.contact) {
        showMessage(message, TEXT.missingFields);
        return;
      }

      setLoading(form, submit, true);

      fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          return response.json().then(function (json) {
            if (!response.ok) {
              throw new Error(json.error || TEXT.orderNotFound);
            }

            return json;
          });
        })
        .then(function (data) {
          renderResult(root, data);
          showMessage(message, TEXT.statusLoaded, true);
        })
        .catch(function (error) {
          result.hidden = true;
          showMessage(message, error.message || TEXT.genericError);
        })
        .finally(function () {
          setLoading(form, submit, false);
        });
    });
  }

  function buildEndpoint(apiUrl) {
    var value = apiUrl.trim().replace(/\/+$/, "");

    if (!value) return "";
    if (value.slice(-16) === "/api/track-order") return value;

    return value + "/api/track-order";
  }

  function prefillFormFromUrl(form) {
    var params = new URLSearchParams(window.location.search);
    var orderNumber = params.get("order") || params.get("orderNumber") || "";
    var contact = params.get("contact") || "";

    if (orderNumber && form.elements.orderNumber) {
      form.elements.orderNumber.value = orderNumber;
    }

    if (contact && form.elements.contact) {
      form.elements.contact.value = contact;
    }
  }

  function renderResult(root, data) {
    var result = root.querySelector(SELECTORS.result);
    var statusLabel = root.querySelector(SELECTORS.statusLabel);
    var statusDescription = root.querySelector(SELECTORS.statusDescription);
    var orderName = root.querySelector(SELECTORS.orderName);
    var trackingNumber = root.querySelector(SELECTORS.trackingNumber);
    var timeline = root.querySelector(SELECTORS.timeline);

    statusLabel.textContent = data.status && data.status.label ? data.status.label : TEXT.statusUpdating;
    statusDescription.textContent = data.status && data.status.description ? data.status.description : "";
    orderName.textContent = data.order && data.order.name ? data.order.name : "-";
    trackingNumber.textContent = data.tracking && data.tracking.number ? data.tracking.number : TEXT.trackingUnavailable;

    renderTimeline(timeline, Array.isArray(data.timeline) ? data.timeline : []);

    result.hidden = false;
  }

  function renderTimeline(container, timeline) {
    container.textContent = "";

    timeline.forEach(function (step) {
      var item = document.createElement("li");
      var dot = document.createElement("span");
      var label = document.createElement("span");

      item.className = "track-order__timeline-step";
      if (step.complete) item.className += " is-complete";
      if (step.active) item.className += " is-active";

      dot.className = "track-order__timeline-dot";
      dot.setAttribute("aria-hidden", "true");

      label.className = "track-order__timeline-label";
      label.textContent = step.label || "";

      item.appendChild(dot);
      item.appendChild(label);
      container.appendChild(item);
    });
  }

  function setLoading(form, submit, isLoading) {
    form.setAttribute("aria-busy", isLoading ? "true" : "false");
    submit.disabled = isLoading;
    submit.textContent = isLoading ? TEXT.loading : TEXT.submit;
  }

  function showMessage(message, text, success) {
    message.textContent = text;
    message.classList.toggle("is-success", Boolean(success));
  }

  function clearMessage(message) {
    showMessage(message, "", false);
  }
})();
